import React, { Component } from 'react';
import './elo-detail.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import HomeworkApi from '../../../../apis/homework'
import CommonUtils from '../../../../utility/common-utilities';

class ConceptDetail extends Component {

    state = {
        title: "Knowing Our Numbers",
        conceptsName: ["Large Numbers in Practice", "Estimation", "Numbers upto 1 lakh"],
        conceptsInfo: [
            {
                title: "Large Numbers in Practice",
                elos: [
                    [{ title: "Solve the word problems using operations on large numbers", skill: "KNOWLEDGE" }, { title: "Multiply two large numbers", skill: "KNOWLEDGE" }],
                    [{ title: "Use of large numbers in metric system", skill: "CALCULATION" }],
                    [{ title: "Find the difference of two large numbers", skill: "COMPREHENSION" }]
                ]
            },
            {
                title: "Estimation",
                elos: [
                    [{ title: "Find a strategy to solve real life problems by estimating results", skill: "KNOWLEDGE" }, { title: "Estimate the difference of two or more numbers", skill: "KNOWLEDGE" }, { title: "Estimate the sum of two numbers", skill: "KNOWLEDGE" }],
                    [{ title: "Understand the need for estimation and rounding off", skill: "CALCULATION" }],
                    [{ title: "Round off numbers to nearest thousands", skill: "COMPREHENSION" }]
                ]
            },
            {
                title: "Numbers upto 1 lakh",
                elos: [
                    [{ title: "Solve the word problems using operations on large numbers", skill: "KNOWLEDGE" }, { title: "Multiply two large numbers", skill: "KNOWLEDGE" }],
                    [{ title: "Use of large numbers in metric system", skill: "CALCULATION" }],
                    [{ title: "Find the difference of two large numbers", skill: "COMPREHENSION" }]
                ]
            },
        ]
    }

    constructor(props) {
        super(props)
        this.state.conceptsInfo = this.props.item.conceptBuild
        let conceptsName = []
        for (let i = 0; i < this.props.item.conceptBuild.length; i++) {
            conceptsName.push(this.props.item.conceptBuild[i].title)
        }
        this.state.title = this.props.item.chapter
        this.state.conceptsName = conceptsName
        this.state.createdDate = this.props.item?.createdDate ? CommonUtils.datePipe(this.props.item.createdDateTimestamp, false) : ''
    }

    componentDidMount() {
        // this.getHomeworkDetail()
        console.log(this.props.item)
       
        //console.log(this.state.createdDate)
    }

    getHomeworkDetail(payload = {}) {

        // if (payload.page) payload.page = 1
        // if (payload.page) payload.limit = this.limit
        // payload.type = this.props.type

        if (this.props.selectedItem) {
            payload.homeworkId = this.props.selectedItem._id
        }

        HomeworkApi.getHomeworkDetail(payload)
            .then(response => {

                console.log("response", response)
                this.setState({ noviceStudents: response.noviceStudents, proficientStudents: response.proficientStudents, advancedStudents: response.advancedStudents })

            }).catch(err => {
            })
    }

    expand = (item, index) => {
        let homeworkList = this.state.homeworkList
        homeworkList[index].expand = !homeworkList[index].expand
        this.setState({ homeworkList })
    }

    onClickTab = (index) => {
        this.setState({ activeTabIndex: index })
    }

    onClickBack = () => {
        this.props.back()
    }

    onClickInfo = () => {
        this.setState({ showInfoModal: true })
    }

    hideInfoModal = () => {
        this.setState({ showInfoModal: false })
    }

    getColor(skill) {
        let colors = Constants.SKILLS_COLOR
        let color = colors[skill]
        return color
    }

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event?.target?.value })
    }

    renderStudentCard = (student) => {
        return (
            <div className="cw-card student p-4 ">
                <div className=" flex">
                    <div className="profile-avatar text-center mr-2 d-inline-block">
                        <div className="row justify-content-center">
                            <img className="" alt="img" src={student?.image} />
                        </div>
                    </div>
                    <div className="pl-2 d-inline-block">
                        <div className="student-name">{student?.name}</div>
                        <div className="student-roll-number">Roll no - {student?.rollNumber}</div>
                    </div>
                </div>
            </div>
        )
    }

    renderList = () => {
        return (
            this.state.conceptsInfo?.map((concept, index) => (

                <div className="concept-wrapper">
                    <div className="concept-index">Concept {index + 1}</div>
                    <div className="concept-title pt-2">{concept?.title}</div>
                    <div >
                        {
                            concept.elos.length ? concept.elos.map((elo, levelIndex) => (
                                <div>
                                    <div className="elo-index pt-4">Level {levelIndex + 1} </div>
                                    {
                                        elo.map(item => (
                                            <div className="row pt-3 ml-3">
                                                <div className="col-12 elo-title"><span className='mr-2'>•</span>{item?.title}</div>
                                                {/* <div className="col-2 my-auto text-center"><span className="skill px-2 py-1" style={{ background: this.getColor(item?.skill) }}>{item?.skill}</span></div> */}
                                            </div>
                                        ))
                                    }
                                </div>
                            ))
                                :
                                ""

                        }
                    </div>
                </div>
            ))
        )
    }

    render() {
        return (
            <div className='concept-detail'>

                <div className="abs-image">
                    <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                </div>

                <div className="row pt-4">
                    {/* <div className="col-10">
                        <div className="row m-0 search">
                            <div className="col-10">
                                <input className={`search-input`} placeholder='Search'
                                    value={this.state.search}
                                    onChange={(e) => this.onChangeHandler(e, 'search')} />
                            </div>
                            <div className="col-2 my-auto text-right"><img className='search-icon cursor-pointer' src={getImageSource(ImageConstants.SEARCH)} /></div>
                        </div>
                    </div> */}
                    <div className="col text-right my-auto"><img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={() => this.onClickBack()} /></div>
                </div>

                <div className="chapter-wrapper">
                <div className="row">
                        <div className="col-9"><span className="concept-title">{`${this.props.item.type === 'STANDARD' || this.props.item.type === 'ADAPTIVE'  ? "Homework" : 'Classwork'} Created On ${this.state.createdDate}`} </span></div>
                    </div>
                    <div className="row">
                        <div className="col-9"><span className="concept-title">Chapter : {this.state.title} </span></div>
                    </div>

                    <div className="pt-4">
                        <div className="concept-index">{`${this.state.conceptsName?.length == 1 ? 'Concept' : 'Concepts'} Covered in the ${this.props.item.type === 'STANDARD' || this.props.item.type === 'ADAPTIVE' ? "Homework" : 'Classwork'}`}</div>
                        <div className="">
                            {
                                this.state.conceptsName.map(chapter => (
                                    <div className="chapter-name pt-2">{chapter} </div>
                                ))
                            }</div>
                    </div>
                </div>

                <div>
                    {this.renderList()}
                </div>
            </div >
        );
    }
}

export default ConceptDetail;